import { render, staticRenderFns } from "./serviceDetailBox.vue?vue&type=template&id=74c8bf37"
import script from "./serviceDetailBox.vue?vue&type=script&lang=js"
export * from "./serviceDetailBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports